import * as constants from '../constants/tags'

import Api from '../services/api.js'

export function getTagsRequest(){
  return {
    type: constants.GET_TAGS_REQUEST,
  }
}

export function getTagsSuccess(body){
  return {
    type: constants.GET_TAGS_SUCCESS,
    body: body
  }
}

export function getTagsFailure(exception){
  return {
    type: constants.GET_TAGS_FAILURE,
    exception: exception
  }
}

export function getTags(params) {
  return dispatch => {
    dispatch(getTagsRequest())
    const api = new Api();
    return api.get("/api/v1/tags", { params: params })
    .then(response => {
      dispatch(getTagsSuccess(response.data))
    })
    .catch(err => dispatch(getTagsFailure(err)));
  }
}

export function getCategorizedTagsRequest(){
  return {
    type: constants.GET_CATEGORIZED_TAGS_REQUEST,
  }
}

export function getCategorizedTagsSuccess(body){
  return {
    type: constants.GET_CATEGORIZED_TAGS_SUCCESS,
    body: body
  }
}

export function getCategorizedTagsFailure(exception){
  return {
    type: constants.GET_CATEGORIZED_TAGS_FAILURE,
    exception: exception
  }
}

export function getCategorizedTags() {
  return dispatch => {
    dispatch(getCategorizedTagsRequest())
    const api = new Api();
    return api.get("/api/v1/categorized_tags")
    .then(response => {
      dispatch(getCategorizedTagsSuccess(response.data))
    })
    .catch(err => dispatch(getCategorizedTagsFailure(err)));
  }
}

export function getTagRequest(){
  return {
    type: constants.GET_TAG_REQUEST,
  }
}

export function getTagSuccess(body){
  return {
    type: constants.GET_TAG_SUCCESS,
    body: body
  }
}

export function getTagFailure(exception){
  return {
    type: constants.GET_TAG_FAILURE,
    exception: exception
  }
}

export function getTag(params) {
  return dispatch => {
    dispatch(getTagRequest())
    const api = new Api();
    return api.makeRequest({
        method: "get",
        url: "/api/v1/tag/" + params.id,
        timeout: 30000,
        params: params
      })
      .then(response => {
        dispatch(getTagSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(getTagFailure(err))
      })
      .then(() => {
        // do no matter error or success
      });
  }
}

export function getComplianceRatingsRequest(){
  return {
    type: constants.GET_COMPLIANCE_RATINGS_REQUEST,
  }
}

export function getComplianceRatingsSuccess(body){
  return {
    type: constants.GET_COMPLIANCE_RATINGS_SUCCESS,
    body: body
  }
}

export function getComplianceRatingsFailure(exception){
  return {
    type: constants.GET_COMPLIANCE_RATINGS_FAILURE,
    exception: exception
  }
}

export function getComplianceRatings(params) {
  return dispatch => {
    dispatch(getComplianceRatingsRequest())
    const api = new Api();
    return api.makeRequest({
        method: "get",
        url: "/api/v1/tag/" + params.tag_id + "/compliance_ratings",
        timeout: 30000,
        params: params
      })
      .then(response => {
        // success callback
        dispatch(getComplianceRatingsSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(getComplianceRatingsFailure(err))
      })
      .then(() => {
        // do no matter error or success
      });
  }
}

export function updateTagRequest(){
  return {
    type: constants.UPDATE_TAG_REQUEST,
  }
}

export function updateTagSuccess(data){
  return {
    type: constants.UPDATE_TAG_SUCCESS,
    body: data
  }
}

export function updateTagFailure(exception){
  return {
    type: constants.UPDATE_TAG_FAILURE,
    exception: exception
  }
}

export function updateTag(details) {
  return dispatch => {
    dispatch(updateTagRequest())
    const api = new Api();
    return api.put("/api/v1/tags", details)
    .then(response => {
      dispatch(updateTagSuccess(response.data))
    })
    .catch(err => dispatch(updateTagFailure(err)));
  }
}

export function createTagRequest(){
  return {
    type: constants.CREATE_TAG_REQUEST,
  }
}

export function createTagSuccess(body){
  return {
    type: constants.CREATE_TAG_SUCCESS,
    body: body
  }
}

export function createTagFailure(exception){
  return {
    type: constants.CREATE_TAG_FAILURE,
    exception: exception
  }
}

export function createTag(details) {
  return dispatch => {
    dispatch(createTagRequest())
    const api = new Api();
    return api.post("/api/v1/tags", details)
    .then(response => {
      dispatch(createTagSuccess(response.data))
    })
    .catch(err => dispatch(createTagFailure(err)));
  }
}

export function getTagsComplianceRatingsRequest(){
  return {
    type: constants.GET_TAGS_COMPLIANCE_RATINGS_REQUEST,
  }
}

export function getTagsComplianceRatingsSuccess(body){
  return {
    type: constants.GET_TAGS_COMPLIANCE_RATINGS_SUCCESS,
    body: body
  }
}

export function getTagsComplianceRatingsFailure(exception){
  return {
    type: constants.GET_TAGS_COMPLIANCE_RATINGS_FAILURE,
    exception: exception
  }
}

export function getTagsComplianceRatings(params) {
  return dispatch => {
    dispatch(getTagsComplianceRatingsRequest())
    const api = new Api();
    return api.makeRequest({
        method: "get",
        url: "/api/v1/tags_compliance_ratings",
        params: params
      })
      .then(response => {
        // success callback
        dispatch(getTagsComplianceRatingsSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(getTagsComplianceRatingsFailure(err))
      })
      .then(() => {
        // do no matter error or success
      });
  }
}




// WEBPACK FOOTER //
// ./src/actions/tags.js